module.exports = __webpack_public_path__ + "img/iconlogo.34725345.png";